/*
 * Copyright (c) 2021. American Express Company
 */

import React, { Component, ReactComponentElement } from 'react';
import Typography from '../../components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import { ClickableTileMood, ClickableTileViewModel } from 'src/types/view-models/clickable-tile.view.model';
// stylesheets
import styles from './ClickableTile.module.scss';

export default class ClickableTile extends Component<ClickableTileViewModel> {
    public override render(): ReactComponentElement<any> {
        return (
            <div
                className={styles.clickableTileContainer}
                style={{ width: this.props.width, height: this.props.height }}
                onClick={this.props.action?.bind(this)}
            >
                {this.getLeftIcon()}
                {this.getStatus()}
                {this.getRightIcon()}
                {this.getRightText()}
            </div>
        );
    }

    private getLeftIcon(): JSX.Element {
        return this.props.leftIcon ? <div>{this.props.leftIcon}</div> : null;
    }

    private getRightIcon(): JSX.Element {
        return this.props.rightIcon ? <div>{this.props.rightIcon}</div> : null;
    }

    private getRightText(): JSX.Element {
        return this.props.rightText ? (
            <div className={styles.rightText}>
                <Typography variant={TypographyVariants.CAPTION}>{this.props.rightText}</Typography>
            </div>
        ) : null;
    }

    private getStatus(): JSX.Element {
        if (!this.props.status) return null;
        let status: string = this.props.status;

        let dot: JSX.Element = null;
        let emphasizedWord: JSX.Element = null;
        switch (this.props.mood) {
            case ClickableTileMood.BAD:
                dot = <span className={styles.badDot}></span>;
                if (this.props.emphasizedWord)
                    emphasizedWord = <span className={styles.bad}>{this.props.emphasizedWord}</span>;
                break;
            case ClickableTileMood.GOOD:
                dot = <span className={styles.goodDot}></span>;
                if (this.props.emphasizedWord)
                    emphasizedWord = <span className={styles.good}>{this.props.emphasizedWord}</span>;
                break;
            case ClickableTileMood.WARN:
                dot = <span className={styles.warnDot}></span>;
                if (this.props.emphasizedWord)
                    emphasizedWord = <span className={styles.warn}>{this.props.emphasizedWord}</span>;
                break;
        }

        if (this.props.amount) status = status.replace('$amount', this.props.amount);

        const statusWords: string[] = this.props.emphasizedWord ? status.split(this.props.emphasizedWord) : [];

        return (
            <div className={styles.status}>
                <Typography variant={TypographyVariants.SUBTEXT}>
                    {dot}
                    {statusWords.length ? statusWords[0] : status}
                    {emphasizedWord}
                    {statusWords.length > 1 ? statusWords[1] : null}
                </Typography>
            </div>
        );
    }
}
